/* ==========================================================================
   HP LAB — hp-quick-search-engine.js
   ADAPTADOR MÍNIMO. Ya no tiene ranking, filtro de marca, fallback ni
   normalización propios — todo eso vive en el motor único, hp-search-engine.js
   (HPLab.SearchEngine), compartido con el diagnóstico.

   Este archivo existe solo por compatibilidad de nombre de asset. El
   controlador del buscador flotante (hp-quick-search-controller.js) llama
   directo a window.HPLab.SearchEngine — no depende de este adaptador.
   Requiere que hp-search-engine.js se cargue ANTES en el HTML.
   ========================================================================== */
window.HPQuickSearch = window.HPQuickSearch || {};
HPQuickSearch.Engine = (window.HPLab && window.HPLab.SearchEngine) || null;
